export default __webpack_public_path__ + "static/media/cog.ca076821.svg";